import React from 'react'
import { Link } from 'react-router-dom'
import { SavingTypesWrapper, Wrapper } from './style'
import { DashboardRight } from 'src/assets'
import { addNairaSign } from 'src/utils/addNairaSign'
import { SwiperSlide, Swiper } from 'swiper/react'
import { SavingsSlider } from './SavingsSlider'
import { EmergencyIcon, TargetIcon, GeneralIcon } from 'src/assets'
import { useTypedSelector } from 'src/redux/root-reducer'
import {
  DashboardGeneral,
  DashboardTarget,
  DashboardEmergency,
} from 'src/assets'
interface ISavingsLinkItems {
  id: number
  title: string
  cardNumber: string
  cardText: string
  Icon: any
  className: string
  link: string
}
const SavingsTypes = () => {
  const portfolio = useTypedSelector(
    (state) => state.portfolios.portfolio.accounts.saving_plans
  )
  const SavingsLinkItems: ISavingsLinkItems[] = [
    {
      id: 1,
      title: 'General Savings',
      cardNumber: portfolio?.general,
      cardText: 'Save for your periodic goals',
      Icon: DashboardGeneral,
      className: 'general',
      link: '/general-savings',
    },

    {
      id: 2,
      title: 'Target Savings',
      cardNumber: portfolio?.target,
      cardText: 'Strict savings for your goals',
      Icon: DashboardTarget,
      className: 'target',
      link: '/target-savings',
    },

    {
      id: 3,
      title: 'Emergency Savings',
      cardNumber: portfolio?.emergency,
      cardText: 'Save for unplanned but urgent needs (Flex)',
      Icon: DashboardEmergency,
      className: 'emergency',
      link: '/emergency-savings',
    },
  ]
  return (
    <Wrapper>
      <div className="large">
        <SavingTypesWrapper>
          {SavingsLinkItems.map((item) => (
            <Link to={item.link} className="saving-link">
              <div className="item-height" key="item.id">
                <div className="title">
                  <img src={item.Icon} alt="" />
                  <div className="cardinfo">
                    <h3 className="savings-title">{item.title}</h3>
                    <p className="paragraph">{item.cardText}</p>
                  </div>
                </div>
                <div className="links">
                  <p className="black">{item.cardNumber}</p>
                  <img src={DashboardRight} alt="" />
                </div>
              </div>
            </Link>
          ))}
        </SavingTypesWrapper>
      </div>
    </Wrapper>
  )
}

export { SavingsTypes }
